import React from 'react'
import { css } from 'aphrodite'
import { Col, Row } from 'reactstrap'

import style from './style'

export const ResponseAlert = props => {
  const alert =
    (props.content || props.altContent) && props.alert ? props.alert : 'hide'

  return (
    <Row className={css(style.alert.fileAlertWrapper, style.alert[alert])}>
      <Col className={css(style.alert.fileAlertBox)}>
        <span className={css(style.alert.fileAlertSpan)}>
          {props.content || props.altContent}
        </span>
      </Col>
    </Row>
  )
}

export default ResponseAlert



// WEBPACK FOOTER //
// ./src/components/partials/ResponseAlert/index.js